export const TemplatesUserPermissions = {
  MayViewTemplates: 'T-MVT',
  MayCreateTemplates: 'T-MCT',
};

export const TemplatesAdminPermissions = {
  ...TemplatesUserPermissions,
  MayArchiveTemplates: 'T-MAT',
};

export const TemplatesPermissions = {
  ...TemplatesAdminPermissions,
};
